import React from 'react';
import classes from './BoxInfo.css';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import ErrorIcon from '@material-ui/icons/Error';

const BoxInfo = ({ children, type = "info" }) => {
  const iconMap = {
    success: <CheckCircleIcon style={{ color: "#646464" }} />,
    info: <InfoIcon style={{ color: "#646464" }} />,
    warning: <WarningIcon style={{ color: "#646464" }} />,
    error: <ErrorIcon style={{ color: "#646464" }} />,
  };

  return (
    <div className={`${classes.BoxStepInfoContainer} ${classes[`BoxStepInfo-${type}`]}`}>
      {iconMap[type]}
      <div className={classes.TextoInfo}>{children}</div>
    </div>
  );
};
export default BoxInfo;
